import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../../environments/environment.prod';
import { StudentsNotes } from 'src/app/_models/academic/notes/NoteModels';
import { BaseComponent } from '../../../../../_base/base.component';

@Component({
  selector: 'app-note-student-grid',
  templateUrl: './note-student-grid.component.html',
  styleUrls: ['./note-student-grid.component.scss']
})
export class NoteStudentGridComponent extends BaseComponent implements OnInit {
  url = environment.apiUrl;
  @Input() isEditMode: boolean;
  @Input() student: StudentsNotes;
  @Input()
  selectedStudents: {
    studentId: string;
    studentName: string;
    studentNameEn: string;
  }[];
  @Input() isChecked: boolean = false;
  @Input() isManageNote: boolean = true;
  @Output() selectedStudentEmitter = new EventEmitter();
  @Output() studentNotesEmitter = new EventEmitter();
  selectedStudentId: string = '';

  constructor(private modalservice: BsModalService) {
    super();
  }

  ngOnInit() {}
  onChangedCheckbox(studentId: string, name: string, nameEn: string): void {
    this.selectedStudentEmitter.emit([studentId, name, nameEn]);
  }
  isCheckedStatus(studentId: string): boolean {
    if (this.isChecked) return true;
    else return this.selectedStudents.findIndex(item => item.studentId === studentId) !== -1 ? true : false;
  }
  getImageUrl(imageUrl: string): string {
    return imageUrl ? this.getImage(imageUrl) : '../../assets/Images/users/default-user.jpg';
  }

  onClickButton(studentId) {
    this.studentNotesEmitter.emit(studentId);
  }
}
